import { trpc } from '../config/trpc';

/**
 * The admin's counterpart to the customer app's hook of the same name.
 *
 * Customer only ever sees the keys the API marks public, so it is handed the whole map
 * through a context at the root. An admin is allowed the entire config tree, so this reads
 * `getAllConfigs` directly instead of standing up a second provider — react-query dedupes
 * the query, so every caller shares one fetch.
 *
 * Values arrive as `{}` on the first render and populate once the query settles; treat a
 * missing key as "not configured" rather than blocking on it.
 */
export const usePeliConfig = (category: string): Record<string, any> => {
  const { data } = trpc.getAllConfigs.useQuery();

  return data?.configs?.[category] ?? {};
};
